import React from "react";
import { Button } from "../../../basic-ui-components/button/base/button.component";
import { BalanceButtonsGroupBox } from "./boxes/balance-buttons-group.box";
import { ButtonWrapperBox } from "./boxes/button-wrapper.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {observer} from "mobx-react";

export const UserBalanceButtons: React.FC = observer(() => {
    const services = useServices();
    const translator = services.translation;

    const openDeposit = async () => {
        (await services.userMenu).launchDeposit();
    }

    const openWithdraw = async () => {
        (await services.userMenu).launchWithdraw();
    }

    return (
        <BalanceButtonsGroupBox>
            <ButtonWrapperBox className="cy-deposit-button">
                <Button preset="special" onClick={openDeposit} fullWidth>
                    {translator.translate('DEPOSIT')}
                </Button>
            </ButtonWrapperBox>
            <ButtonWrapperBox className="cy-withdraw-button">
                <Button preset="info" onClick={openWithdraw} fullWidth>
                    {translator.translate('WITHDRAW')}
                </Button>
            </ButtonWrapperBox>
        </BalanceButtonsGroupBox>
    );
})
